import script from "./PreviewList.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewList.vue?vue&type=script&setup=true&lang=js"

import "./PreviewList.vue?vue&type=style&index=0&id=051e8512&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051e8512"]])

export default __exports__